export const TIEP_DON_VARIABLE = {
  SERVICE: "service"
}

export const PROVINCE_PREFIX = ["Tỉnh ", "Thành phố "];
export const DISTRICT_PREFIX = ["Huyện ", "Quận ", "Thị xã ", "Thành Phố "];
export const WARD_PREFIX = ["Xã ", "Phường ", "Thị trấn "];
export const TRIMMED_PROVINCE_PREFIX = ["Tỉnh", "Thành phố"];
export const TRIMMED_DISTRICT_PREFIX = ["Huyện", "Quận", "Thị xã", "Thành Phố"];
export const TRIMMED_WARD_PREFIX = ["Xã", "Phường", "Thị trấn"];

export const ADDRESS_PREFIX = {
  PROVINCE_PREFIX,
  DISTRICT_PREFIX,
  WARD_PREFIX,
  TRIMMED_PROVINCE_PREFIX,
  TRIMMED_DISTRICT_PREFIX,
  TRIMMED_WARD_PREFIX,
}
